import React from "react";
import { FaBullseye, FaEye, FaUsers } from "react-icons/fa";
import image1 from "../images/ceo.png";
import image2 from "../images/cfo.png";
import image3 from "../images/coordinator.png";
import image4 from "../images/developer.png";

function About() {
    const leaders = [
        { image: image1, name: "Nikhil Dubey", role: "CEO & Founder & Developer" },
        { image: image2, name: "Shashikant Singh Dubey", role: "CFO & Co-Founder" },
        { image: image3, name: "Prashant Dubey", role: "Project Manager" },
        { image: image4, name: "Abhinav", role: "Developer" },
    ];

    return (
        <main className="inner-page">
            <section className="inner-hero" aria-labelledby="about-title">
                <div className="ciits-container">
                    <div className="inner-hero-content">
                        <span className="ciits-eyebrow">About our company</span>
                        <h1 id="about-title">About <span className="gradient-text">CIITS</span></h1>
                        <p>
                            CIITS (Central India IT Services) delivers innovative, reliable, and scalable IT solutions to help businesses thrive in a digital-first world. Our expert team is dedicated to customer satisfaction and technological excellence.
                        </p>
                    </div>
                </div>
            </section>

            <section className="about-story-section" aria-label="CIITS mission and vision">
                <div className="ciits-container">
                    <div className="about-dual-grid">
                        <article className="about-purpose-card">
                            <div className="about-purpose-label" aria-hidden="true"><FaBullseye /></div>
                            <h2>Our Mission</h2>
                            <p>
                                To empower businesses with advanced IT solutions that automate processes, enhance digital presence, and drive sustainable growth. We focus on innovation, efficiency, and tailored services for every client.
                            </p>
                        </article>

                        <article className="about-purpose-card">
                            <div className="about-purpose-label" aria-hidden="true"><FaEye /></div>
                            <h2>Our Vision</h2>
                            <p>
                                To be India's leading IT services provider, delivering impactful solutions for businesses of all sizes. We foster a culture of growth, collaboration, and excellence in everything we do.
                            </p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="leadership-section" aria-labelledby="leadership-title">
                <div className="ciits-container">
                    <div className="ciits-section-heading ciits-section-heading--center">
                        <span className="ciits-eyebrow"><FaUsers size={12} /> Our people</span>
                        <h2 id="leadership-title" className="ciits-title">
                            Meet Our <span className="gradient-text">Leadership</span>
                        </h2>
                    </div>

                    <div className="team-grid">
                        {leaders.map((leader) => (
                            <article className="team-card-modern" key={leader.name}>
                                <div className="team-image-wrap">
                                    <img src={leader.image} alt={leader.name} />
                                </div>
                                <div className="team-info">
                                    <h3>{leader.name}</h3>
                                    <p>{leader.role}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default About;
